import { c as _c } from "react/compiler-runtime";
import React from "react";
import { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { ApiWave } from "@/generated/models/ApiWave";
import { WaveSmallLeaderboardItemOutcomes } from "@/components/waves/small-leaderboard/WaveSmallLeaderboardItemOutcomes";
interface WaveLeaderboardDropFooterProps {
  readonly drop: ExtendedDrop;
  readonly wave: ApiWave;
}
export const WaveLeaderboardDropFooter: React.FC<WaveLeaderboardDropFooterProps> = t0 => {
  const $ = _c(3);
  const {
    drop,
    wave
  } = t0;
  let t1;
  if ($[0] !== drop || $[1] !== wave) {
    t1 = <WaveSmallLeaderboardItemOutcomes drop={drop} wave={wave} />;
    $[0] = drop;
    $[1] = wave;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};